import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setWidgetEffectiveCols } from '../redux/datasourceSlice.js';
import { DatasourceContext } from '../gen2_widgets/base/DatasourceEngineGrid.jsx';
import useDatasourceQuery from './useDatasourceQuery.js';
import useDatasourceV2Channel from './useDatasourceV2Channel.js';
import DatasourceV2Notice from './DatasourceV2Notice.jsx';
import { WIDGETS_WITH_PAGED_DATA, datasourceKey } from './constants.js';

/**
 * v2 counterpart of DatasourceEngineGrid: fills the same DatasourceContext with rows filtered and
 * aggregated on the server, so widgets reading the context work unchanged.
 */
function DatasourceV2Provider({ widgetId, children }) {
  const dispatch = useDispatch();
  const widgetType = useSelector((state) => state.dashboard.widgets[widgetId]?.widget_type);
  // Paged widgets (grid) query their visible rows themselves
  const paged = WIDGETS_WITH_PAGED_DATA.includes(widgetType);
  const { datasourceId, rows, cols, values, truncated, meta, status } = useDatasourceQuery(widgetId, { enabled: !paged });
  useDatasourceV2Channel(paged ? null : datasourceId);

  // Settings sidebar column pickers (outside this context tree) read the output columns from Redux
  useEffect(() => {
    if (!paged) dispatch(setWidgetEffectiveCols({ widgetId, cols }));
  }, [dispatch, widgetId, cols, paged]);

  const value = useMemo(() => ({
    filteredRows: rows,
    cols,
    // Distinct column values (button filters)
    values,
    datasourceId: datasourceKey(datasourceId),
    status,
    meta,
    truncated,
  }), [rows, cols, values, datasourceId, status, meta, truncated]);

  return (
    <DatasourceContext.Provider value={value}>
      {children}
      <DatasourceV2Notice status={status} truncated={truncated} rowCount={rows.length} meta={meta} />
    </DatasourceContext.Provider>
  );
}

export default DatasourceV2Provider;
